import React from 'react';
import { Button, Icon } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';
import colors from '@packages/core/styles/colors';

const useStyles = createUseStyles({
    container: {
        border: `1px solid ${colors.grayThree}`,
        borderRadius: 4,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 2,
        height: 40,
        minHeight: 40,
        paddingLeft: 2,
        paddingRight: 2,
    },
    actionContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

interface ActionItem {
    name: string;
    icon: string;
    isVisible: boolean;
    isDisabled?: boolean;
    onPress?: () => void;
}

interface DynamicGridActionIconsProps {
    isDeleteDisabled?: boolean;
    onDelete?: () => void;
    onCopy?: () => void;
    onPopover?: () => void;
}

export function DynamicGridActionIcons({ isDeleteDisabled, onDelete, onCopy, onPopover }: DynamicGridActionIconsProps) {
    const classes = useStyles();

    const actions: ActionItem[] = [
        {
            name: 'Menu',
            icon: 'more-dots-vertical',
            isVisible: !!onPopover,
            isDisabled: false,
            onPress: () => onPopover && onPopover(),
        },
        {
            name: 'Copy',
            icon: 'copy',
            isVisible: false,
            isDisabled: false,
            onPress: () => onCopy && onCopy(),
        },
        {
            name: 'Delete',
            icon: 'x-close',
            isVisible: !!onDelete,
            isDisabled: isDeleteDisabled,
            onPress: () => onDelete && onDelete(),
        },
    ].filter((action) => action.isVisible);

    if (!actions.length) {
        return null;
    }

    return (
        <>
            <div className={classes.container}>
                {actions.map((action, index) => {
                    return (
                        <div key={`${action.name}-${index}`} className={classes.actionContainer}>
                            <Button
                                variant="ghost-blue"
                                disabled={action.isDisabled}
                                onPress={action.onPress}
                                size="small"
                                style={{ height: 32, width: 32 }}
                                focusable={false}
                            >
                                <Icon name={action.icon} color="blueOne" />
                            </Button>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
